<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
	[titleImg]="titleImgConfig"
	[testHook]="testHooks.TitleSection"
>
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-6 h-fit">
			<div class="flex flex-col gap-4">
				<h4 class="text-lg font-medium text-gray-950 m-0">Provider</h4>
				<div class="font-medium text-gray-900 text-sm">Teranet</div>
			</div>
			<div class="flex flex-col gap-4">
				<h4 class="text-lg font-medium text-gray-950 m-0">Fee Placement</h4>

				<app-direction-of-fee-dropdown
					[currentDirectionOfFee]="currentDirectionOfFee()"
					label="Display Line Item(s) In"
					fieldToUpdate="titleSearch.feeSettings.location"
				/>

				<ui-note
					title="Note"
					*ngIf="currentDirectionOfFee() !== directionOfFeeType.NONE"
					[testHook]="testHooks.Note"
				>
					<p>
						Changes will only apply to new matters to avoid impacts to existing
						records
					</p>
				</ui-note>
			</div>
		</div>
		<div
			class="flex flex-col gap-6 h-fit"
			*ngIf="currentDirectionOfFee() !== directionOfFeeType.NONE"
		>
			<h4 class="text-lg font-medium text-gray-950 m-0">Additional Settings</h4>

			<ui-checkbox
				label="Apply HST to all search costs"
				[ngModel]="settings()?.applyHstAll"
				(ngModelChange)="setApplyHstAll($event)"
				[testHook]="testHooks.ApplyHstToAllSearchCostsCheckbox"
			/>

			<ui-checkbox
				label="Combine Property and Writs search costs into a single entry"
				[ngModel]="settings()?.combineTitleAndWritsFees"
				(ngModelChange)="setCombineTitleAndWrits($event)"
				[testHook]="
					testHooks.CombinePropertyAndWritsSearchCostsIntoASingleEntryCheckbox
				"
			/>
		</div>
	</div>
</ui-section>
